import printf from 'printf';

export default (labelFormat, value) => {
    if (!value) return '--';
    const split = labelFormat.split(/{value:|}/);
    const format = `%${split[1]}${split[2]}`;

    return printf(format, value);
};
